export const ADD_CITIZENSHIP = 'ADD_CITIZENSHIP';
export const DELETE_CITIZENSHIP = 'DELETE_CITIZENSHIP';
